import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';
import CardSimple from 'screens/components/basic/CardSimple';
import { reportOnlineInstoreReportCrumb } from 'utils/breadcrumbInfo';
import { formInput, clearFormInput } from 'actions/FormActions';
import { getOrderListSales, getCsvReport } from 'actions/ReportsAction';
import PageHeader from 'screens/components/basic/PageHeader';
import Grid from 'screens/components/basic/Grid';
import Pagination from 'screens/components/basic/Pagination';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import Body from './Body';
import Header from './Header';

class OrderList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showBody: false,
            activePage: 1,
            itemsPerPage: 20,
            totalRow: 0
        }
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        this.cleanSearch();
        const date = new Date();
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1), `OrderListBeginDate`);
        this.props.formInput(date, `OrderListEndDate`);
    }

    cleanSearch = () => {
        this.props.clearFormInput(`OrderListBeginDate`);
        this.props.clearFormInput(`OrderListEndDate`);
        this.props.clearFormInput(`OrderListBranchOption`);
        this.props.clearFormInput(`OrderListType`);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchIds = this.props.orderListBranchOption ? this.props.orderListBranchOption.join(",") : this.props.loggedBranch;
        let pageSize = this.state.itemsPerPage;
        let pageNumber = this.state.activePage;
        let orderType = this.props.selectOrderType || 0;
        let orderPlatform = this.props.selectOrderPlatform || 0;
        let paymentDelivery = this.props.selectPaymentDelivery || 0;

        this.props.getOrderList({ beginDate, endDate, branchIds, orderType, orderPlatform, paymentDelivery, pageNumber, pageSize });
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchIds = this.props.orderListBranchOption ? this.props.orderListBranchOption.join(",") : this.props.loggedBranch;
        let orderType = this.props.selectOrderType || 0;
        let orderPlatform = this.props.selectOrderPlatform || 0;
        let paymentDelivery = this.props.selectPaymentDelivery || 0;
        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/orderlist?beginDate=${beginDate}&endDate=${endDate}&branchIds=${branchIds}&orderType=${orderType}&orderPlatform=${orderPlatform}&paymentDelivery=${paymentDelivery}`, "Order List");
        }
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    componentWillReceiveProps = (newProps) => {
        if (newProps !== this.props) {
            if (this.state.showBody) {
                const totalRow = newProps.orderListSales && newProps.orderListSales.list && newProps.orderListSales.list.length > 0 ? newProps.orderListSales.total : 0;
                this.setState({ totalRow: totalRow });
            }
        }
    }

    render() {
        return (
            <Grid headerContent={reportOnlineInstoreReportCrumb}>
                <PageHeader title={LOOKUP.report.orderList.text} description={LOOKUP.report.orderList.description}/>
                    {(!this.props.branchOptions || this.props.branchOptions.length == 0) &&
                    <div style={{ color: `red` }} className="row m-0 pa-2"><h5>No branches available to query</h5></div>}

                <Header
                    branchOptions={this.props.branchOptions}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch.toString()}
                    disabled={this.props.branchOptions && this.props.branchOptions.length == 0}
                    orderTypes={this.props.orderTypes}
                    orderPlatforms={this.props.orderPlatforms}
                    orderPaymentDelivery={this.props.orderPaymentDelivery}
                    selectOrderType={this.props.selectOrderType}
                />
                {
                    this.state.showBody && this.props.orderListSales &&
                    <CardSimple>
                        <Body
                            orderListSales={this.props.orderListSales}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                        />
                        <Pagination
                            length={this.state.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    let orderTypes =
        [
            { text: "All", value: "0" },
            { text: "In Store", value: "1" },
            { text: "Online", value: "2" },
        ];
    let platforms =
        [
            { text: "All", value: "0" },
            { text: "TechPOS", value: "3" },
            { text: "Buddi", value: "4" },
            { text: "Dutchie", value: "5" },
            { text: "Leafly", value: "6" },
            { text: "Kiosk", value: "10" }
        ]
    let paymentDelivery =
        [
            { text: "All", value: "0" },
            { text: "Pay In Store", value: "7" },
            { text: "Paid Online & Store Pickup", value: "8" },
            { text: "Paid Online & Delivery", value: "9" }
        ]

    return {
        branchOptions: branchOptions,
        orderTypes: orderTypes,
        orderPlatforms: platforms,
        orderPaymentDelivery: paymentDelivery,
        orderListSales: state.reports.orderListSales,
        loggedBranch: state.common.branchId,
        beginDate: state.form.OrderListBeginDate,
        endDate: state.form.OrderListEndDate,
        branch: state.form.OrderListBranchOption,
        selectOrderType: state.form.OrderListOrderType,
        selectOrderPlatform: state.form.OrderListOrderPlatform,
        selectPaymentDelivery: state.form.OrderListPaymentDelivery,
        orderListBranchOption: state.form.OrderListBranchOption
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getOrderList: (model) => dispatch(getOrderListSales(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(OrderList));
